import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import { Field, FormikProvider, useFormik } from 'formik'
import CustomInput from '../../../components/common/CustomInput'
import CustomSelect from '../../../components/common/CustomSelect'
import * as Yup from 'yup'

const validationSchema = Yup.object({
  name: Yup.string().trim().required('State is required'),
  country: Yup.string().trim().required('Country is required'),
})

const Add = () => {
  const navigate = useNavigate()
  const [countryOptions, setCountryOptions] = useState([])

  const fetchCountryData = async () => {
    try {
      const response = await axiosAuthInstance.get('country/dropdown')
      if (response.status === 200) {
        const transformedData = response?.data?.result?.map((item) => ({
          value: item._id,
          label: item.name,
        }))
        setCountryOptions(transformedData)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    fetchCountryData()
  }, [])

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const response = await axiosAuthInstance.post('state/add', {
        name: values.name,
        country: values.country,
      })
      if (response) {
        navigate('/state')
      }
    } catch (error) {
      console.log(error)
    }
  }

  const formik = useFormik({
    onSubmit: (values, formikHelpers) => handleSubmit(values, formikHelpers),
    validationSchema,
    initialValues: {
      name: '',
      country: '',
    },
  })

  return (
    <FormikProvider value={formik}>
      <form
        className='flex flex-col p-4 gap-4'
        onSubmit={(e) => {
          e.preventDefault()
          formik.handleSubmit()
        }}
      >
        <Field
          name='name'
          label='State'
          placeholder='State'
          required
          component={CustomInput}
        />

        {/* Using CustomSelect for country field with options */}
        <Field
          name='country'
          label='Country'
          placeholder='Country'
          required
          component={CustomSelect}
          options={countryOptions} // Pass the list of country options here
        />

        <button
          type='submit'
          disabled={formik.isSubmitting}
          className='bg-primary text-xl font-medium text-white rounded-lg px-6 py-2'
        >
          Add
        </button>
      </form>
    </FormikProvider>
  )
}

export default Add
